import { render, staticRenderFns } from "./AddSalleryFactors.vue?vue&type=template&id=030888cb&scoped=true&"
import script from "./AddSalleryFactors.vue?vue&type=script&lang=js&"
export * from "./AddSalleryFactors.vue?vue&type=script&lang=js&"
import style0 from "./AddSalleryFactors.vue?vue&type=style&index=0&id=030888cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030888cb",
  null
  
)

export default component.exports